import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/appservice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ElectronService } from 'ngx-electron';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { MatMenuTrigger } from '@angular/material';

@Component({
  selector: 'app-view-invoice',
  templateUrl: './view-invoice.component.html',
  styleUrls: ['./view-invoice.component.css']
})
export class ViewInvoiceComponent implements OnInit {

  @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;

  o = true;
  d = false;
  t = false;
  lh = false;
  clh = false;
  cashmemo = false;
  isupdatenote = false;
  note = '';
  public theHtmlString = 'Loading...';
  id: string;
  constructor(public service: AppService, private _route: ActivatedRoute, private electronservice: ElectronService,
    private router: Router) {
    this.o = this.service.getlocalitem('o') != null && this.service.getlocalitem('o') === 'true' ? true : this.o;
    this.d = this.service.getlocalitem('d') != null && this.service.getlocalitem('d') === 'true' ? true : this.d;
    this.t = this.service.getlocalitem('t') != null && this.service.getlocalitem('t') === 'true' ? true : this.t;
    this.lh = this.service.getlocalitem('lh') != null && this.service.getlocalitem('lh') === 'true' ? true : this.lh;
    this.clh = this.service.getlocalitem('clh') != null && this.service.getlocalitem('clh') === 'true' ? true : this.clh;
  }

  ngOnInit() {
    this.loadinvoice();
  }

  loadinvoice() {
    this.id = this._route.snapshot.paramMap.get('id');
    this.service.getRequest('api/invoice/note?id=' + this.id).subscribe(x => {
      this.note = x;
    });
    this.service.getRequestHTML('api/invoice/view?id=' + this.id + (this.cashmemo ? '&cashmemo=1' : '')).subscribe(x => {
      this.theHtmlString = x;
    },
      error => {
        console.log('communication error :' + error);
        this.service.sendMessage('error ');
      });
  }

  print(_isDownload): void {
    this.service.setlocalitem('o', this.o.toString());
    this.service.setlocalitem('d', this.d.toString());
    this.service.setlocalitem('t', this.t.toString());
    this.service.setlocalitem('lh', this.lh.toString());

    let printdata = '';
    if (this.o) {
      printdata += '<div class="page">' + this.theHtmlString + '</div>';
    }
    if (this.d) {
      printdata += '<div class="page">' + this.theHtmlString.replace('[[ORIGINAL]]', '[[DUPLICATE FOR TRANSPORTER]]') + '</div>';
    }
    if (this.t) {
      printdata += '<div class="page">' + this.theHtmlString.replace('[[ORIGINAL]]', '[[TRIPLICATE]]') + '</div>';
    }
    const str = `
    <!DOCTYPE html>
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1,IE=8" />
        <title>Invoice</title>
        <style>
            html {
                display: table;
                margin: auto;
            }

            body {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                min-height:600px;
                width: 210mm;
            }` + (this.lh ? '.header{     visibility: hidden; }' : '')
      + `
            div.page
            {
              page-break-after: always;
              page-break-inside: avoid;
              counter-reset: Count-Value;
              counter-reset: page 1;
            }
          </style>
        </head>
      <body onload="adjustHeight();">${printdata}</body>
      </html>`;

    if (this.electronservice.isElectronApp) {
      const os = this.electronservice.remote.require('os');
      const path = this.electronservice.remote.require('path');
      const htmlPath = path.join(os.tmpdir(), 'print.html');
      console.log(htmlPath);
      const fs = this.electronservice.remote.require('fs');
      fs.writeFileSync(htmlPath, str);
      console.log('Wrotten');
      let win = new this.electronservice.remote.BrowserWindow({ width: 800, height: 600 });
      win.on('close', () => {
        win = null;
        try {

          if (fs.existsSync(htmlPath)) {
            fs.unlink(htmlPath, (err) => {
              if (err) {
                // alert("An error ocurred updating the file" + err.message);
                console.log('An error ocurred updating the file' + err.message);
                return;
              }
            });
          }
        } catch (e) {
          console.log('error delete file : ' + htmlPath);
        }
      });
      if (_isDownload) {
        const options = {
          defaultPath: this.electronservice.remote.app.getPath('documents') + '/invoice.pdf'
        };
        this.electronservice.remote.dialog.showSaveDialog(null, options, (_path) => {
          function pdfSettings() {
            const paperSizeArray = ['A4', 'A5'];
            const option = {
              landscape: false,
              marginsType: 0,
              printBackground: false,
              printSelectionOnly: false,
              pageSize: paperSizeArray[0],
            };
            return option;
          }

          win.webContents.printToPDF(pdfSettings(), function (err, data) {
            if (err) {
              this.service.sendMessage('Oops' + err);
              return;
            }
            try {
              fs.writeFileSync(_path + '/Invoice.pdf', data);
            } catch (err) {
              this.service.sendMessage('Oops' + err);
            }
          });
        });
        return;
      }
      win.loadURL(htmlPath);
      win.show();
      // window.print();
    } else {
      if (_isDownload) {
        let popupWin;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=100%');
        popupWin.document.open();
        popupWin.document.write(str);
        html2canvas(popupWin.document.body).then(function (canvas) {
          // document.body.appendChild(canvas);
          const imgData = canvas.toDataURL(
            'image/png');
          const doc = new jsPDF('p', 'mm');
          doc.addImage(imgData, 'PNG', 10, 10);
          // doc.fromHTML(str, 15, 15);
          doc.save('Invoice.pdf');
        });

      } else {
        let popupWin;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(str);
        popupWin.document.close();
      }
    }
  }

  editNote(): void {
    this.isupdatenote = !this.isupdatenote;
  }

  updateNote(): void {
    const n = { 'id': this.id, 'note': this.note };
    this.service.getRequestData('api/invoice/note', n).subscribe((data) => {
      // console.log(data);
      if (data.Success) {
        this.service.sendMessage('Invoice.SaveSuccess');
        this.isupdatenote = false;
      } else {
        this.service.sendMessage('Oops');
      }
    },
      (err) => {
        // console.log("Item creation failed : " + err);
        this.service.sendMessage('Oops');
      });
  }

  printCover(): void {
    this.service.setlocalitem('clh', this.clh.toString());
    this.service.getRequestHTML('api/invoice/printcover?id=' + this.id).subscribe(x => {
      let printdata = '';
      printdata += '<div class="page">' + x + '</div>';
      const str = `
    <!DOCTYPE html>
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1,IE=8" />
        <title>Invoice</title>
        <style>
            html {
                display: table;
                margin: auto;
            }

            body {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                min-height:600px;
            }` + (this.clh ? '.header{     visibility: hidden; }' : '')
        + `
            div.page
            {
              page-break-after: always;
              page-break-inside: avoid;
              counter-reset: Count-Value;
              counter-reset: page 1;
            }
          </style>
        </head>
      <body onload="adjustHeight();">${printdata}</body>
      </html>`;

      if (this.electronservice.isElectronApp) {
        const os = this.electronservice.remote.require('os');
        const path = this.electronservice.remote.require('path');
        const htmlPath = path.join(os.tmpdir(), 'print.html');
        console.log(htmlPath);
        const fs = this.electronservice.remote.require('fs');
        fs.writeFileSync(htmlPath, str);
        console.log('Wrotten');
        let win = new this.electronservice.remote.BrowserWindow({ width: 800, height: 600 });
        win.on('close', () => {
          win = null;
          try {
            if (fs.existsSync(htmlPath)) {
              fs.unlink(htmlPath, (err) => {
                if (err) {
                  // alert("An error ocurred updating the file" + err.message);
                  console.log('An error ocurred updating the file' + err.message);
                  return;
                }
              });
            }
          } catch (e) {
            console.log('error delete file : ' + htmlPath);
          }
        });
        win.loadURL(htmlPath);
        win.show();
        // window.print();
      } else {
        let popupWin;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(str);
        popupWin.document.close();
      }
    });
  }

  printWarranty(): void {
    this.service.getRequestHTML('api/invoice/warranty?id=' + this.id).subscribe(x => {
      let printdata = '';
      printdata += '<div class="page">' + x + '</div>';
      const str = `
    <!DOCTYPE html>
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1,IE=8" />
        <title>Warranty Certificate</title>
        <style>
            html {
                display: table;
                margin: auto;
            }

            body {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                min-height:600px;
                width: 210mm;
            }
            div.page
            {
              page-break-after: always;
              page-break-inside: avoid;
              counter-reset: Count-Value;
              counter-reset: page 1;
            }
          </style>
        </head>
      <body onload="adjustHeight();">${printdata}</body>
      </html>`;

      if (this.electronservice.isElectronApp) {
        const os = this.electronservice.remote.require('os');
        const path = this.electronservice.remote.require('path');
        const htmlPath = path.join(os.tmpdir(), 'print.html');
        console.log(htmlPath);
        const fs = this.electronservice.remote.require('fs');
        fs.writeFileSync(htmlPath, str);
        console.log('Wrotten');
        let win = new this.electronservice.remote.BrowserWindow({ width: 800, height: 600 });
        win.on('close', () => {
          win = null;
          try {
            if (fs.existsSync(htmlPath)) {
              fs.unlink(htmlPath, (err) => {
                if (err) {
                  // alert("An error ocurred updating the file" + err.message);
                  console.log('An error ocurred updating the file' + err.message);
                  return;
                }
              });
            }
          } catch (e) {
            console.log('error delete file : ' + htmlPath);
          }
        });
        win.loadURL(htmlPath);
        win.show();
        // window.print();
      } else {
        let popupWin;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(str);
        popupWin.document.close();
      }
    }, error => {
      console.log('communication error :' + error);
      this.service.sendMessage('error ');
    });
  }

  delete(): void {
    if (window.confirm('Are sure you want to delete this invoice ?')) {
      this.service.getRequest('api/invoice/delete?id=' + this.id).subscribe(x => {
        if (x.Success) {
          this.service.sendMessage('Invoice.Deleted');
          this.router.navigate(['/invoice/']);
        } else {
          this.service.sendMessage(x.Error);
        }
      },
        error => {
          console.log('communication error :' + error);
          this.service.sendMessage('error ');
        });
    }
  }
}
